import { ReactNode } from 'react'
import { cn } from 'app/lib/utils'

type ReadOnlyFieldProps = {
  label: string
  /** The value to show. Nothing, an empty string or `false` shows the fallback. */
  value?: ReactNode
  /** Shown in place of a missing value. */
  fallback?: string
  /** Extra content beside the label, such as a channel badge. */
  adornment?: ReactNode
  className?: string
  hidden?: boolean
}

/**
 * A label over a value, for settings that are read rather than edited. The
 * label takes the form field's label style and the value the field's text, so
 * a read-only section lines up with an editable one beside it.
 */
export default function ReadOnlyField({
  label,
  value,
  fallback = `Not set`,
  adornment,
  className,
  hidden = false,
}: ReadOnlyFieldProps) {
  const empty = value == null || value === `` || value === false
  return (
    <div className={cn(`flex min-w-0 flex-col gap-1`, className)} hidden={hidden}>
      <span className="flex items-center gap-2 text-label-sm text-default">
        {label}
        {adornment}
      </span>
      {empty ? (
        <span className="text-body-sm text-subtle">{fallback}</span>
      ) : (
        <span className="min-w-0 text-body-sm text-strong">{value}</span>
      )}
    </div>
  )
}
